import React, { useEffect, useState } from "react";
import {
    Box,
} from "@mui/material";
import { useSelector } from "../../../../store";

export default function WebMultipleSelectApplication({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;

    const answerData = data.answer.value ?? questionData.answer.value;

    const [choices, setChoices] = useState({});
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [answerBox, setAnswerBox] = useState(data.answerBox);
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [activeSelect, setActiveSelect] = useState(false);

    const [availableChoices, setAvailableChoices] = useState(
        data.choices
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setChoices({});
        setAnswerBox(data.answerBox);
        setSelectedChoice(null);
        setActiveSelect(false);
        setSelectedKeyPrevious(null);
        setAvailableChoices(data.choices);
    }, [question,
        data.answerBox,
        data.choices,
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setActiveSelect(true);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (choices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === choices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== choices[index]?.value)) {
            let currentChoices = {...choices};
            const previousChoice = choices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentChoices = {
                ...currentChoices,
                [index]: {
                    value: selectedChoice.value,
                    style: selectedChoice.style,
                    type: selectedChoice.type,
                },
            }
            setChoices(currentChoices);

            if (
                typeof answerData === "object" &&
                !Array.isArray(answerData)
            ) {
                const answerKeys = Object.keys(answerData);

                const formattedAnswer = answerKeys.reduce(
                    (acc, key, keyIndex) => {
                        acc[key] = currentChoices[keyIndex]?.value || null;
                        return acc;
                    },
                    {}
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: formattedAnswer,
                });
            } else {
                const updatedAnswer = Object.values(currentChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
            setActiveSelect(false);
        }
    };

    const handleRemoveChoice = (index) => {
        if (!activeSelect) {
            const removedChoice = choices[index];
            
            if (removedChoice) {
                setChoices((prevChoices) => {
                    const newChoices = { ...prevChoices };
                    delete newChoices[index];

                    if (
                        typeof answerData === "object" &&
                        !Array.isArray(answerData)
                    ) {
                        const answerKeys = Object.keys(
                            answerData
                        );

                        const formattedAnswer = answerKeys.reduce(
                            (acc, key, keyIndex) => {
                                acc[key] = newChoices[keyIndex]?.value || null;
                                return acc;
                            },
                            {}
                        );

                        // checking if all answer so that we can make next screen
                        let canProceed = false;
                        Object.keys(formattedAnswer).map((key) => {
                            if (formattedAnswer[key] !== "" && formattedAnswer[key] !== null) {
                                canProceed = true;
                            }
                            return null;
                        });
                        // trigger events for checking if can next button enabled
                        onAnswer({
                            canProceed,
                            answer: formattedAnswer,
                        });

                    } else {
                        const updatedAnswer = Object.values(newChoices).map(
                            (choice) => choice.value
                        );

                        // set to false so that next button will be disabled
                        const canProceed = updatedAnswer.length > 0;
                        onAnswer({
                            canProceed,
                            answer: updatedAnswer,
                        });
                    }

                    return newChoices;
                });

                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    {
                        value: removedChoice.value,
                        style: removedChoice.style,
                        type: removedChoice.type,
                    },
                ]);
            }
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
            }}
        >
            <Box sx={{
                width: "300px",
                height: "400px",
                border: "1px dashed lightgrey",
                textAlign: "center"
            }}>
                <Box sx={{
                    position: "relative",
                    display: "flex",
                    height: "400px",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "10px"
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index} 
                            sx={{
                                fontWeight: "bold",
                                borderBottom: "10px solid rgb(52, 148, 186)",
                                position: "relative",
                                height: "48px",
                                width: "275px",
                                display: "inline-block",
                                backgroundColor: "#aad6e7",
                                padding: "4px",
                                boxShadow:
                                    selectedChoice?.value === choice.value
                                    ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                    : "none",
                                fontSize: "18px",
                            }}
                            onClick={() => { handleChoiceClick(choice) }}
                        >
                            <Box sx={{
                                display: "inline-flex",
                                width: "100%",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                userSelect: "none",
                                pointerEvents: "none",
                                fontSize: "16px",
                                lineHeight: "0.8em",
                                textAlign: "center"
                            }}>{choice.value}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box sx={{
                marginLeft: "10px",
                borderBottom: "10px solid #BF9000",
                textAlign: "center",
                width: "420px",
            }}>
                <Box sx={{
                    backgroundColor: "#FFC000",
                    color: "black",
                    borderBottomWidth: "10px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#BF9000",
                    padding: "8px",
                    paddingRight: "20px",
                    fontSize: "1.25em",
                    textAlign: "left",
                }}>{data.questionHeader}</Box>
                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: "110px 1fr",
                    placeItems: "center right",
                    gap: "10px",
                    padding: "10px",
                    fontSize: "16px",
                    backgroundColor: "#f2f2f2",
                    textAlign: "right",
                }}>
                    {answerBox.map((row, index) => {
                        const Tag = row.type;
                        let style = row.style;
                        if (typeof style != "undefined" && row.addStyle) {

                            let addNewStyle = {
                                borderTop: choices[row.index] ? "none" : "10px solid rgb(91, 105, 106)",
                                backgroundColor: choices[row.index] ? "#aad6e7" : "white",
                                position: 'relative',
                                display: 'inline-block',
                                boxSizing: 'border-box',
                                lineHeight: '0.8em',
                                fontSize: '16px',
                                boxShadow:
                                    selectedChoice
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }

                            style = {...style, ...addNewStyle};
                        }
                        return (
                            <Tag key={index} style={style}
                                onClick={() => handleChoiceAssign(row.index)}
                            >
                                {/* For close button */}
                                {choices[row.index] && (
                                    <Box
                                        className="selected-close-btn"
                                        sx={{
                                            top: "0px",
                                            right: "0px",
                                            fontWeight:
                                                typeof answerData ===
                                                    "object" &&
                                                !Array.isArray(
                                                    answerData
                                                )
                                                    ? "normal"
                                                    : "bold",
                                            width: "17.33px",
                                            maxHeight: "20px",
                                            display: "flex",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveChoice(row.index);
                                        }}
                                    >
                                        X
                                    </Box>
                                )}
                                    {choices[row.index] ? (
                                        <div
                                            style={{
                                                fontWeight: "bold",
                                                display: "inline-flex",
                                                width: "100%",
                                                height: "100%",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                userSelect: "none",
                                                pointerEvents: "none",
                                                fontSize: "16px",
                                                lineHeight: "12px",
                                            }}
                                        >{choices[row.index].value}</div>
                                            ) :
                                            <div style={{ fontSize: "18px"}}>{row.value}</div>
                                        }</Tag>
                        )
                    })}
                </Box>
            </Box>
        </Box>
    );
};
